import { createContext } from "react";

const EntryAndDepartureReportContext = createContext();

export default EntryAndDepartureReportContext